import { useQuery } from '@tanstack/react-query';
import { mediaUtil } from '../utils';
import { cityService, geolocationService } from '../../services/homii-services';
import _ from 'lodash';
import getConfig from 'next/config';
import { CONSTANTS } from '../../../utils/constants';

async function fetchAllCitiesData() {
    const fetchedCities = await cityService.getAllCities();
    const citiesWithImages = mediaUtil.generateCityImageUrls(fetchedCities);
    const citiesObject = {};
    _.forEach(citiesWithImages, (city) => {
        citiesObject[city.id] = city;
    });
    return citiesObject;
}

async function fetchCityByName(cityName) {
    let selectedCity =  null;
    if(cityName === CONSTANTS.NEARBY) {
        selectedCity =  await fetchClosestCity();
    }else{
        const cities  = await fetchAllCitiesData();
        selectedCity = _.find(cities, { name: cityName });
    }
    return selectedCity;    
}

async function fetchClosestCity () {    
    const { publicRuntimeConfig } = getConfig();
    let geolocatedData = null;
    if (publicRuntimeConfig.HOMII_FEATURE_PAID_GEO_SERVICE) {
        geolocatedData = await geolocationService.getGeolocationDetails();
    }
    if (!geolocatedData) {
        geolocatedData = await geolocationService.getGeolocationDetailsFallback();
    }
    const latitude = _.get(geolocatedData, 'latitude');
    const longitude = _.get(geolocatedData, 'longitude');
    if(latitude !== undefined && longitude !== undefined) {
        const fecthedCity = await cityService.getClosestCity(latitude, longitude, null);
        return fecthedCity;
    }   
    const defaultCity = await fetchCityByName('Durban');    
    return defaultCity;
};

export const useCitiesData = () => {
    return useQuery({
        queryKey: ['cities'],
        queryFn: fetchAllCitiesData,
        staleTime: 1000 * 60 * 60, 
    });
};

export const useCityById = (cityId) => {
    return useQuery({
        queryKey: ['city', cityId],
        queryFn: async () => {
            const allCities = await fetchAllCitiesData(); 
            const selectedCity = _.find(allCities, { id: cityId });
            if (!selectedCity) {
                throw new Error(`City with ID ${cityId} not found.`);
            }
            return selectedCity;
        },
        staleTime: 1000 * 60 * 60, 
        enabled: !!cityId, 
    });
};

export const useSelectedCity = () => {
    return useQuery({
        queryKey: ['selectedCity'],
        queryFn: fetchClosestCity, 
        staleTime: 1000 * 60 * 60, 
    });
};

export const useCityByName = (cityName) => {
    return useQuery({
        queryKey: ['cityName', cityName],
        queryFn: async () => {
            let selectedCity =  null;
            if(cityName === CONSTANTS.NEARBY || cityName === "" || cityName === undefined) {
                selectedCity =  await fetchClosestCity();
            }else{
                const cities  = await fetchAllCitiesData();
                selectedCity = _.find(cities, { name: cityName });
            }
            return selectedCity;            
        },
        staleTime: 1000 * 60 * 60
    });
};

export default {    
    fetchAllCitiesData,        
    fetchClosestCity,
};
